module.exports = __webpack_public_path__ + "img/player_icon.02371699.png";